import React from "react";

const PlanTitle = ({ title }) => (
  <span className="plan-title">{title}</span>
);

export default PlanTitle;
